/**
 * Request body for Api V2 PayPal order creation.
 * @see App\Http\Controllers\Api\V2\Payment\PayPalController::create
 */
export class PayPalCreateOrderDto {
  constructor(data) {
    this.domain = data.domain;
    this.id = String(data.id);
    this.amount = Number(data.amount).toFixed(2);
  }
}

/**
 * Build PayPal create payload for class registration retest flow.
 * @param {import('../models/package').Package | null} retestPackage Selected retest package.
 * @param {number} registrationId Class registration id.
 * @param {number} amount Amount to charge (net of any discount).
 * @returns {PayPalCreateOrderDto | null}
 */
export function toRetestPayPalCreateOrderDto(retestPackage, registrationId, amount) {
  if (!retestPackage) {
    return null;
  }
  return new PayPalCreateOrderDto({
    domain: retestPackage.name,
    id: registrationId,
    amount,
  });
}
